<template>
    <v-card flat tile outlined style="overflow:hidden">
        <v-card-title>
            <span> 근로계약 출근내역 </span>
        </v-card-title>
        <v-divider class="primary border-2" />
        <v-data-table
            v-bind="{
                items,
                headers,
                mobileBreakPoint: $vuetify.breakpoint.thresholds.sm,
            }"
            disable-filtering
            disable-pagination
            disable-sort
            hide-default-footer
            class=" rounded-0"
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }">
                <div :key="header.value">{{ header.formatter(value, item) }}</div>
            </template>
        </v-data-table>
        <v-divider />
        <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" class="employment-contract-view-logs__pagination" />

        <client-loader v-bind="{ loading }" />
    </v-card>
</template>

<script>
import api from "@/api";
import { initEmploymentContract } from "@/assets/variables";

import ClientLoader from "@/components/client/dumb/client-loader.vue";
import { ATTENDANCE_LOG_TYPES } from "@/store/attendance";

const headers = [
    {
        text: "#",
        value: "index",
        width: +80,
        align: "end",
    },
    {
        text: "유형",
        value: "type",
        formatter: (value) => ATTENDANCE_LOG_TYPES[value]?.text || "-",
    },
    {
        text: "생성일시",
        value: "createdAt",
        formatter: (value) => value?.toDateTime?.() || value || "-",
        width: 200,
    },
].map((item, index, array) => ({ ...item, divider: index < array.length - 1 }));

export default {
    components: {
        ClientLoader,
    },
    props: {
        value: { type: Object, default: initEmploymentContract },
    },
    data: () => ({
        logs: [],
        summary: { totalCount: 0 },

        page: 1,
        limit: 10,

        loading: false,

        headers,
    }),
    computed: {
        items() {
            return this.logs.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { _id: _contract } = this.value;

            return {
                _contract,
            };
        },
    },
    mounted() {
        this.init().then(this.search);
    },
    watch: {
        params() {
            this.init().then(this.search);
        },
        limit() {
            this.init().then(this.search);
        },
        page() {
            this.search();
        },
    },
    methods: {
        async init() {
            this.page = 1;
            this.logs = [];
            this.summary = { totalCount: 0 };
            this.selected = [];
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { skip, limit, params } = this;
                const { summary, logs } = await api.v1.company.attendance.logs.gets({
                    headers: { skip, limit },
                    params,
                });
                this.summary = summary;
                this.logs = logs;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.employment-contract-view-logs {
    &__pagination {
        margin: 8px 0;
        & ::v-deep ul {
            margin: 0 !important;
        }
    }
}
</style>
